/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-13 20:26:10
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ProductCarousel/index.tsx
 */
import React from 'react';

import _ProductCarousel from 'src/components/Modules/ProductCarousel';

import ContentGroupHOC from '../HOC';
import { compose } from 'redux';

const ProductCarousel = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,

    handleItemOnSort,
    handleOnStaticsChange,

    droppableId,
    handleOnItemDeleteAll,
    handleOnReselect,
    // specificError,
  } = props || {};

  return (
    <_ProductCarousel
      staticData={staticData} //staticData
      products={dynamicData.map((i) => {
        const { productName } = i || {};
        return { ...(i || {}), name: productName };
      })} //products
      onItemDelete={handleOnItemDelete} //onItemDelete
      onItemSort={handleItemOnSort} //onItemSort
      onStaticChange={handleOnStaticsChange} //onStaticChange
      onItemDeleteAll={handleOnItemDeleteAll} //onItemDeleteAll
      onItemReselect={handleOnReselect} //onItemReselect
      droppableId={droppableId} //droppableId
    />
  );
};
export default compose(ContentGroupHOC)(ProductCarousel);
